import './Herostyles.css';
import introHero from '../images/hero1.jpg';
import React from 'react';
import { Link } from 'react-router-dom';
import Typed from 'react-typed';
import styled, {keyframes} from 'styled-components';
import { useInView } from 'react-intersection-observer';


const Heroimg = () => {

    const { ref: myRef, inView: VisibleElement} = useInView();

    let timeOfDay;
    const date = new Date();
    const hours = date.getHours();
    const styles = {
      fontSize: 18,
    }
  
    if (hours < 12) {
      timeOfDay = 'morning';
      styles.color = "#fff";
    } else if (hours >= 12 && hours < 17) {
      timeOfDay = 'afternoon';
      styles.color = "#fff";
    } else {
      timeOfDay = 'evening';
      styles.color = "#fff";
    }


return (
    <div className="hero">
        <div className='mask'>
        <img className='Heroimage' src={introHero} alt="Heroimg" width={1500} height={1500}/>
        </div>
        <div ref={myRef} className='content'>
        <Inside style={styles}> Good {timeOfDay}!</Inside>
            <Inside className={`${VisibleElement}`}>HI, I AM SHITSAMA JOHN.</Inside>
            <div>
            <h1 className={`${VisibleElement}`}>
                <Typed
                strings={[
                    "A Software Engineer.",
                    "A Music Producer.",
                    "A Sound Engineer.",
                    "A Business Consultant.",
                    "A Developer."
                ]}
                typeSpeed={50}
                backSpeed={100}
                smartBackspace
                loop
                />
            </h1>
            </div>
            <div className='mt-1'>
                <Link to="/project" className='btn'>Projects</Link>
                <Link to="/contact" className='btn btn-light'>Contact</Link>
            </div>
        </div>
        
    </div>
)
}
const textfade = keyframes `
from {
  opacity: 0;
  transform: translateY(-100px);
}
to {
  opacity: 1;
  transform: translateY(0px);
}
`
;
const Inside = styled.p`
animation-name: ${textfade};
animation-duration: 2500ms;
`


export default Heroimg